import "@orestbida/iframemanager";
import * as CookieConsent from "vanilla-cookieconsent";
import { CONSENT_SERVICES } from "./consentServices";

export function initIframeManager(translations, lang) {
  const im = window.iframemanager();

  im.run({
    currLang: lang,

    onChange: ({ changedServices, eventSource }) => {
      if (eventSource.type === "click" && eventSource.action === "accept") {
        for (const service of changedServices) {
          const category = CONSENT_SERVICES[service].category;
          const currentlyAccepted =
            CookieConsent.getUserPreferences().acceptedServices[category] || [];
          CookieConsent.acceptService([...currentlyAccepted, service], category);
        }
      }
    },

    services: {
      youtube: {
        embedUrl: "https://www.youtube-nocookie.com/embed/{data-id}?rel=0",
        thumbnailUrl: "https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg",
        iframe: {
          allow:
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
          allowfullscreen: true,
          referrerpolicy: "strict-origin-when-cross-origin",
        },
        languages: {
          [lang]: {
            notice: translations.youtube.notice,
            loadAllBtn: translations.youtube.loadAllBtn,
          },
        },
      },
      vimeo: {
        embedUrl: "https://player.vimeo.com/video/{data-id}?dnt=1",
        iframe: {
          allow: "autoplay; fullscreen; picture-in-picture",
          allowfullscreen: true,
          referrerpolicy: "strict-origin-when-cross-origin",
        },
        languages: {
          [lang]: {
            notice: translations.vimeo.notice,
            loadAllBtn: translations.vimeo.loadAllBtn,
          },
        },
      },
      arnes: {
        embedUrl: "https://video.arnes.si/embed/{data-id}",
        iframe: {
          allow: "autoplay; fullscreen; picture-in-picture",
          allowfullscreen: true,
          referrerpolicy: "strict-origin-when-cross-origin",
        },
        languages: {
          [lang]: {
            notice: translations.arnes.notice,
            loadAllBtn: translations.arnes.loadAllBtn,
          },
        },
      },
      googlemaps: {
        embedUrl: "https://www.google.com/maps/embed?pb={data-id}",
        iframe: {
          allow: "fullscreen; picture-in-picture",
          allowfullscreen: true,
          referrerpolicy: "strict-origin-when-cross-origin",
        },
        languages: {
          [lang]: {
            notice: translations.googlemaps.notice,
            loadBtn: translations.googlemaps.loadBtn,
            loadAllBtn: translations.googlemaps.loadAllBtn,
          },
        },
      },
    },
  });

  return im;
}
